/**
 * Host Photo Checklist Question
 *
 * This file contains a React component called HostPhotoChecklistQuestion that represents a 
 * photo checklist question for a host. It allows the host to see what photo checklist questions 
 * were completed by a particular team, and verify them if necessary. The component has a state 
 * that keeps track of whether the question has been checked, initialized, and the photo associated 
 * with the question. The component renders a preview of the photo, the point value of the question, 
 * and the description of the question. The component also has a method to select the image and a 
 * lifecycle method to initialize the state. The component is exported as the default export of the file.
 */

import React from 'react'

class HostPhotoChecklistQuestion extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      checked: false,
      initialized: false,
      photo: null,
    }
    this.initialize = this.initialize.bind(this)
    this.selectImage = this.selectImage.bind(this)
  }

  componentDidMount() {
    this.initialize()
  }

  componentDidUpdate() {
    this.initialize()
  }

  initialize() {
    if (!this.state.initialized && this.props.checked !== this.state.checked) {
      this.setState({
        checked: this.props.checked,
        photo: this.props.photo,
        initialized: true,
      })
    }
  }

  selectImage() {
    this.props.onSelect(this.state.photo)
  }

  render() {
    const { question } = this.props
    return (
      <div className="checklist-item-wrapper">
        <div className="photo-checklist-question mb-3 row no-gutters">
          {this.state.photo && (
            <div className="col-4 text-center">
              <div
                className="img-preview w-100 h-100"
                style={{ backgroundImage: `url(${this.state.photo.image})` }}
                onClick={this.selectImage}></div>
            </div>
          )}

          <div className={this.state.photo ? `col-8` : `col-12`}>
            <div className="photo-heading px-3 py-3 text-right header-data">{question.answer_value} pts</div>
            <div className="py-3 px-3" dangerouslySetInnerHTML={{ __html: question.description }} />
          </div>
        </div>
      </div>
    )
  }
}

export default HostPhotoChecklistQuestion
